import styled from 'styled-components';

export const FormFooter = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 16px;
`;

export const ClosedButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
`
